document.addEventListener("DOMContentLoaded", function () {
  const dialog = document.querySelector("dialog");
  const dialogContent = document.querySelector('[data-type="dialog-content"]');

  if (!dialog) { return };

  dialog.addEventListener("click", (event) => {
    event.preventDefault();

    if (!dialogContent.contains(event.target)) {
      dialog.close();
    }
  });
});
